import React from 'react'
import { format, isToday } from 'date-fns'
import { Button, Spinner } from 'reactstrap'
import SuccessConfettireg from '../../../assets/check-reg.png'
import { ReactComponent as CopyIcon } from '../../../assets/copyIcon.svg'
import styles from 'components/Registration/Form/signupStyles.module.css'

import { getExamType, decryptMobile } from 'utils/common'
import { connect } from 'react-redux'
import {
    SET_TOAST_DATA,
    SET_TOKEN,
    SET_ROLLNO,
    SET_DOB,
} from 'constants/actionTypes'
import { webEngageDob } from 'utils/dateTime'
import axios from 'axios'
import { login, examUrlTP } from 'api/api'
import CONFIG from 'config'

const mapDispatchToProps = (dispatch) => ({
    setToastMsgsData: (payload) => {
        dispatch({ type: SET_TOAST_DATA, payload })
    },
    setToken: (payload) => dispatch({ type: SET_TOKEN, payload }),
    setRollNo: (payload) => dispatch({ type: SET_ROLLNO, payload }),
    setDOB: (payload) => dispatch({ type: SET_DOB, payload }),
})

const SignupSuccessful = ({
    signupSuccessDetails,
    setToastMsgsData,
    setToken,
    setRollNo,
    setDOB,
}) => {
    const [examSlot, setExamSlot] = React.useState('')
    const [isBeginTestLoading, setIsBeginTestLoading] = React.useState(false)
    const getThankYouCTACase = (examDateString, vendorSlot) => {
        localStorage.removeItem('otp_recovery_data');
        const now = new Date()

        const isSameDay =
            new Date(examDateString + 'T00:00:00').toDateString() ===
            now.toDateString()

        const currentTime = format(now, 'HHmm')
        const [start, end] = (vendorSlot || '').split('-')

        if (isSameDay) {
            if (currentTime >= start && currentTime <= end) {
                return 'CASE_1' // Begin Test + Dashboard
            }
            return 'CASE_2' // Only Dashboard (outside time window)
        }

        return 'CASE_3' // Only Dashboard (not today)
    }

    const ctaCondition =
        getExamType() === 'iACST'
            ? getThankYouCTACase(
                  signupSuccessDetails.exam_date,
                  signupSuccessDetails.vendor_slot,
              )
            : 'CASE_3'

    React.useEffect(() => {
        const storedSlot = localStorage.getItem('exam_slots')

        if (storedSlot) {
            setExamSlot(storedSlot)
        }
    }, [])
    React.useEffect(() => {
        window.scroll({
            top: window.innerWidth > 768 ? 130 : 375,
            behavior: 'smooth',
        })
    }, [])

    const examType = getExamType()
    const isNeetMockRoute = 'MOCK-NEET' === examType

    React.useEffect(() => {
        const urlWithParams = new URL(window.location.href)
        urlWithParams.searchParams.set('pmstatus', 'success')
        urlWithParams.searchParams.set('dob', signupSuccessDetails.dob)
        urlWithParams.searchParams.set('roll_no', signupSuccessDetails.roll_number)
        urlWithParams.searchParams.set('exam_date', signupSuccessDetails.exam_date)
        urlWithParams.searchParams.set(
            'vendor_slot',
            signupSuccessDetails.vendor_slot,
        )
        urlWithParams.searchParams.set('registeration', 'success')

        window.history.replaceState({}, '', urlWithParams.href)
        window.dataLayer.push({
            event: 'iacst_complete_registration_v1',
        })
        // Clean up function to revert the URL back to its original state
        return () => {
            window.history.replaceState({}, '', window.location.href)
        }
    }, [])

    React.useEffect(() => {
        if (
            isNeetMockRoute ||
            examType == 'IAT' ||
            (examType == 'MOCK-JEE' &&
                localStorage.getItem('user_info') &&
                localStorage.getItem('exam_info'))
        ) {
            let user_infodata = localStorage.getItem('user_info')
                ? JSON.parse(localStorage.getItem('user_info'))
                : ''
            let exam_infodata = localStorage.getItem('exam_info')
                ? JSON.parse(localStorage.getItem('exam_info'))
                : ''
            window.webengage.track(examType + '6_payment_status_success', {
                'utm parameters': localStorage.getItem('utmParams')
                    ? localStorage.getItem('utmParams')
                    : '',
                'mobile number': user_infodata.mobileNumber
                    ? user_infodata.mobileNumber
                    : '',
                board: exam_infodata.schoolBoard?.value
                    ? exam_infodata.schoolBoard?.value
                    : '',
                student_name: user_infodata.studentName
                    ? user_infodata.studentName
                    : '',
                dob: new Date(user_infodata.dob) ? new Date(user_infodata.dob) : '',
                email_ID: user_infodata.email ? user_infodata.email : '',
                class: exam_infodata.classStream?.class
                    ? exam_infodata.classStream?.class
                    : '',
                city: user_infodata.city ? user_infodata.city : '',
                page_url: window.location.href ? window.location.href : '',
                pincode: user_infodata.pincode ? user_infodata.pincode : '',
                state: user_infodata.state ? user_infodata.state : '',
                exam_mode: localStorage.getItem('exam_mode'),
                exam_state: exam_infodata.state?.label
                    ? exam_infodata.state?.label
                    : '',
                'branch name': exam_infodata.centre?.label
                    ? exam_infodata.centre?.label
                    : '',
                'branch code': exam_infodata.centre?.centreCode
                    ? exam_infodata.centre?.centreCode
                    : '',
                exam_date: new Date(
                    exam_infodata.dateOfExam?.value + 'T03:30:00.000Z',
                )
                    ? new Date(exam_infodata.dateOfExam?.value + 'T03:30:00.000Z')
                    : '',
                dashboard_password: webEngageDob(user_infodata.dob)
                    ? webEngageDob(user_infodata.dob)
                    : '',
                payment_status: 'success',
                exam_type: examType,
                exam_fee: localStorage.getItem('exam_fee')
                    ? Number(localStorage.getItem('exam_fee'))
                    : 0,
                psid: localStorage.getItem('user_psid')
                    ? localStorage.getItem('user_psid')
                    : '',
                coupon_code: localStorage.getItem('coupon_code')
                    ? localStorage.getItem('coupon_code')
                    : '',
            })
        }
    }, [])

    React.useEffect(() => {
        if (isNeetMockRoute || examType == 'IAT' || examType == 'MOCK-JEE') {
            window.webengage.track(examType + '8_Thank_You_Page', {
                'utm parameters': localStorage.getItem('utmParams')
                    ? localStorage.getItem('utmParams')
                    : '',
                roll_number: signupSuccessDetails.roll_number,
                exam_type: examType,
                dob: signupSuccessDetails.dob,
            })
        }
    }, [])

    const handleCopyRollNum = () => {
        if (isNeetMockRoute || examType == 'IAT' || examType == 'MOCK-JEE') {
            window.webengage.track(examType + '9_Thank_You_rollno_copy', {
                'utm parameters': localStorage.getItem('utmParams')
                    ? localStorage.getItem('utmParams')
                    : '',
                roll_number: signupSuccessDetails.roll_number,
                exam_type: examType,
                dob: signupSuccessDetails.dob,
            })
        }
        navigator.clipboard
            .writeText(signupSuccessDetails.roll_number)
            .then(function () {
                setToastMsgsData({
                    isToastOpen: true,
                    toastType: 'warn',
                    toastMessage: 'Copied to clipboard !',
                })
            })
            .catch((err) => {
                setToastMsgsData({
                    isToastOpen: true,
                    toastType: 'error',
                    toastMessage: 'Could not copy text.',
                })
            })
    }

    const formattedDate = () => {
        return format(new Date(signupSuccessDetails.exam_date), 'dd MMM yyyy')
    }

    const isExamToday = isToday(new Date(signupSuccessDetails.exam_date))

    const startTest = async () => {
        setIsBeginTestLoading(true)
        try {
            const { roll_number, dob } = signupSuccessDetails

            let loginEndpoint = CONFIG.LOGIN_API
            if (getExamType() === 'iACST') {
                loginEndpoint += '?exam_type=iACST&web_request_id='
            }
            const loginRes = await axios.post(
                loginEndpoint,
                {
                    roll_number,
                    date_of_birth: dob,
                },
                {
                    headers: { 'Content-Type': 'application/json' },
                },
            )
            const token = loginRes.data?.data?.token || loginRes.data?.token
            if (!token) throw new Error('No token returned from loginAccess')

            // Persist the login session using Redux
            setToken(token)
            setRollNo(roll_number)
            setDOB(dob)

            const profileRes = await axios.get(CONFIG.PROFILE_API, {
                headers: { token: token },
            })
            const profileData = profileRes.data?.data
            if (!profileData) throw new Error('No profile data returned')

            const encryptedMobile = profileData.mobile_number || profileData.mobile_no;
            const ivBase64 = profileData.mobile_number_iv || profileData.mobile_no_iv || profileData.iv;
            const decryptedMobile = decryptMobile(encryptedMobile, ivBase64);

            let data = {
                dob: profileData.student_dob,
                roll_no: profileData.roll_number,
                test_attempt: profileData.test_attempt_count,
                test_start_date: profileData.exam_date_id,
                exam_Type: profileData.exam_type,
                stream: profileData.stream,
                class_studying: profileData.class,
                exam_slot: profileData.exam_mode_and_slot,
                vendor_slot: profileData.vendor_slot,
                test_type: 'Scholarship',
                name: profileData.student_firstname,
                father_name: profileData.father_name,
                center_name: profileData.exam_center,
                mobile: decryptedMobile,
                center_code: profileData.branch_code,
                student_type: 'Regular',
                state_id: profileData.state_id,
                branch_phone: profileData.customer_support_number,
                career_type: 'RCC',
            }

            const tpUrlRes = await examUrlTP(data, token)

            if (tpUrlRes?.data?.data?.exam_url) {
                window.open(
                    tpUrlRes.data.data.exam_url,
                    '_blank',
                    'noopener,noreferrer',
                )
            } else {
                throw new Error('No exam URL returned')
            }
        } catch (error) {
            console.error('Error starting test:', error)
            setToastMsgsData({
                isToastOpen: true,
                toastType: 'error',
                toastMessage: 'Could not start the exam. Please try again.',
            })
        } finally {
            setIsBeginTestLoading(false)
        }
    }

    return (
        <>
            <div className="text-center p-3 pb-0">
                <img src={SuccessConfettireg} alt="success" className="w-2" />
                <p className="fw-lighter font-size-lg text-dark-green">
                    Registration Successful
                </p>
            </div>

            <div className="px-lg-4 px-3 my-4 text-light-grey-200">
                <div>
                    <p className="fw-lighter mb-2">Login details</p>
                    <div className="d-flex align-item-center justify-content-between">
                        <p className="font-size-sm mb-0">
                            Roll number:{' '}
                            <span className="fw-500">
                                {signupSuccessDetails.roll_number}
                            </span>
                        </p>

                        <p
                            className="text-aqua fw-lighter font-size-xs mb-0 cursor-pointer"
                            onClick={handleCopyRollNum}
                        >
                            Copy
                            <span className="ms-2">
                                <CopyIcon />
                            </span>
                        </p>
                    </div>

                    <div className="d-flex align-item-center justify-content-between mt-1">
                        <p className="font-size-sm">
                            Password:{' '}
                            <span className="fw-500">
                                {signupSuccessDetails.dob}
                            </span>
                        </p>
                        <p className="text-grey font-size-xs">Date of birth</p>
                    </div>
                </div>

                {getExamType() !== 'MOCK-JEE' && (
                    <div style={{ borderTop: '2px dotted #757575' }}>
                        <p className="fw-lighter mt-3 mb-2">Exam schedule</p>
                        {signupSuccessDetails.exam_date && (
                            <p className="font-size-sm mb-1">
                                {formattedDate(signupSuccessDetails.exam_date)} |{' '}
                                {examSlot}
                            </p>
                        )}
                    </div>
                )}
            </div>

            <div className="p-3 pb-2 shadow-top">
                {getExamType() !== 'MOCK-NEET' && (
                    <p className="text-center fw-500 font-size-sm text-grey-black">
                        {examType === 'iACST'
                            ? ctaCondition === 'CASE_1'
                                ? "You're all set. Click below to start your test"
                                : 'For test prep guidance'
                            : getExamType() === 'MOCK-JEE'
                              ? 'To access your test series'
                              : isExamToday
                                ? 'To begin the test'
                                : 'For test prep guidance'}
                    </p>
                )}

                {getExamType() === 'iACST' && ctaCondition === 'CASE_1' && (
                    <Button
                        className={`btn btn-aqua text-white w-100 fw-bold font-size-sm mb-3 ${styles.sendOtpButton}`}
                        onClick={startTest}
                        disabled={isBeginTestLoading}
                    >
                        {isBeginTestLoading ? <Spinner size="sm" /> : 'Begin Test'}
                    </Button>
                )}

                <Button
                    className={`btn w-100 fw-bold font-size-sm ${
                        ctaCondition === 'CASE_1'
                            ? styles.dashboardButton
                            : styles.primaryButton
                    } ${styles.sendOtpButton}`}
                    onClick={() => {
                        if (
                            isNeetMockRoute ||
                            examType == 'IAT' ||
                            examType == 'MOCK-JEE'
                        ) {
                            window.webengage.track(
                                examType + '10_Thank_You_Go_To_Dashboard',
                                {
                                    'utm parameters': localStorage.getItem(
                                        'utmParams',
                                    )
                                        ? localStorage.getItem('utmParams')
                                        : '',
                                    dob: signupSuccessDetails.dob,
                                    exam_type: examType,
                                    roll_number: signupSuccessDetails.roll_number,
                                },
                            )
                        }

                        // window.location.href =
                        //     signupSuccessDetails?.dashboard_link ||
                        //     `${window.location.origin}/?roll_no=${signupSuccessDetails.roll_number}&dob=${signupSuccessDetails.dob}`

                        const utmRaw = localStorage.getItem('utmParams')
                        let finalUrl = ''

                        if (utmRaw && examType == 'iACST') {
                            try {
                                const utmParams = JSON.parse(utmRaw)
                                const queryParams = new URLSearchParams(utmParams)
                                finalUrl = signupSuccessDetails?.dashboard_link
                                    ? `${signupSuccessDetails?.dashboard_link}&${queryParams.toString()}`
                                    : `${window.location.origin}/?roll_no=${signupSuccessDetails.roll_number}&dob=${signupSuccessDetails.dob}`
                                window.location.href = finalUrl
                            } catch (e) {
                                console.error(
                                    'Invalid UTM Params in localStorage',
                                    e,
                                )
                            }
                        } else {
                            window.location.href =
                                signupSuccessDetails?.dashboard_link ||
                                `${window.location.origin}/?roll_no=${signupSuccessDetails.roll_number}&dob=${signupSuccessDetails.dob}`
                        }
                    }}
                >
                    Go to dashboard
                </Button>
            </div>
        </>
    )
}

export default connect(null, mapDispatchToProps)(SignupSuccessful)
